export function replicate(n: number): number[] {
  return Array.from({ length: n }, (_, i) => i);
}
